export default __webpack_public_path__ + "static/media/slider-madrid-1.f712e1d9.jpg";